import * as React from 'react';
import CardButton from "./CardButton";
import styled from 'styled-components';
import bg from '../../assets/img/ourStoryHomeBG.jpg';
import cardImg from '../../assets/img/homeGTK.png';
import {BodyContainer} from "../Container/Container";

const Container = BodyContainer.extend`
  
  background-size: 100%;
  background: url(${bg}) no-repeat bottom;
  display: grid;
  grid-gap: 24px;
  
  
  @media(min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    padding-top: 80px;
    padding-bottom: 160px;
    background: url(${bg}) no-repeat ;
  }
  
  @media(min-width: 992px) {
    padding-top: 160px;
  }
`;

const Img = styled.img`
  align-self: center;
  width: 100%;
 
  @media(min-width: 768px) {
    order: 2;
  }
`;

const StyledCardButton = styled(CardButton)`
  @media(min-width: 768px) {
    order: 1
  }
`;

const OurStory = (props) => {
    const {header, paragraph} = props.data;
    return (
      <Container>
          <Img src={cardImg} alt="H & N Fish Co. Founder Hua Ngo"/>
          <StyledCardButton
            header={header}
            subtitle={paragraph}
            buttonText="Our Story"
            link="get-to-know#ourstory"
            title="H & N Group Story"
          />
      </Container>
    );
};

export default OurStory;



// WEBPACK FOOTER //
// ./src/components/Home/OurStory.js